import { Icon, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { TransactionStatus } from '@features/bankTransactions/types/transactionStatus'

import { statusConfig } from './consts/statusConfig'
import * as Styled from './styles'

interface StatusIndicatorProps {
  status: TransactionStatus
}

export const StatusIndicator = ({ status }: StatusIndicatorProps): ReactElement => {
  const { t } = useTranslation()
  const { icon, color, backgroundColor, translationKey } = statusConfig[status]

  const renderIcon = () => {
    const iconElement = <Icon icon={icon} color={color} size={backgroundColor ? 'xs' : 'md'} />

    if (backgroundColor) {
      return (
        <Styled.IconBackgroundWrapper backgroundColor={backgroundColor}>{iconElement}</Styled.IconBackgroundWrapper>
      )
    }

    return iconElement
  }

  return (
    <Tooltip label={t(translationKey)} placement="top">
      {renderIcon()}
    </Tooltip>
  )
}
